import _ax from './_ax';

export function getConfig(){
	return _ax.get('config');
}
